// extracted by mini-css-extract-plugin
export default {"fullWidth":"CommonMultiSelectField_fullWidth__9EC-g"};